import "@babel/polyfill";
import fetch from 'unfetch';
import Vue from 'vue'
import App from './App.js'
import ApolloClient from 'apollo-client-preset'
import { HttpLink } from 'apollo-link-http'
import VueApollo from 'vue-apollo'
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import introspectionQueryResultData from '../fragmentTypes.json';
import { InMemoryCache } from 'apollo-cache-inmemory';
import axios from 'axios'

const fragmentMatcher = new IntrospectionFragmentMatcher({ introspectionQueryResultData });

const cache = new InMemoryCache({ fragmentMatcher });

let graphToken = ''
let origin = window.location.origin

axios.get(`${origin}/manager/user/getpublictoken`).then(
  res => {
    graphToken = res.data
    const httpLink = new HttpLink({uri: `${origin}/graphql?token=${graphToken}`, fetch: fetch});
    // const httpLink = new HttpLink({uri: `${origin}/graphql?token=15af9d011b2ce8ac601781b48ff74262b73e9fb8`});

    const apolloClient = new ApolloClient({
      cache,
      link: httpLink,
      connectToDevTools: true
    });

    Vue.use(VueApollo);

    const apolloProvider = new VueApollo({
      defaultClient: apolloClient
    });

    new Vue({
      el: '#app',
      apolloProvider,
      render: h => h(App)
    });
  }
)



// WEBPACK FOOTER //
// ./src/main.js